<ng-container *ngIf="viewModel$ | async as vm">
  <div class="border border-secondary rounded flex-grow-1">
    <iframe
      #webInternal
      class="h-100 w-100"
      [src]="vm.webUrl"
      style="border: 0"
      title="webInternal"
    ></iframe>
  </div>
</ng-container>
